import { ButtonGroup, FormattedMessage } from '@subaio/components'

import type {
	OpportunityCarInsuranceStep,
	OpportunityCarInsuranceStepType,
} from 'containers/OpportunityCarInsurance/handlers'

import { ButtonText } from 'components/Buttons'
import { Card } from 'components/Card'
import { IconAbn, IconDocumentLoop } from 'components/Icons'
import { Header, PointItem, PointList } from 'components/Layout'

import { Title } from '../Title'

type Props = TaggedType<OpportunityCarInsuranceStep, OpportunityCarInsuranceStepType.HowItWorks> & {
	onStepBack?: () => void
}

export const HowItWorks = ({ onStepBack }: Props) => (
	<Card>
		<Header>
			<Title>
				<FormattedMessage id='opportunityCarInsurance.howItWorks.title' defaultMessage='How does it work?' />
			</Title>
		</Header>
		<PointList>
			<PointItem>
				<IconAbn />
				<div>
					<p role='text'>
						<FormattedMessage
							id='opportunityCarInsurance.howItWorks.stepOne'
							defaultMessage='Your current car insurance is compared on price and conditions with an ABN AMRO car insurance. You can compare all terms and conditions in the app.'
						/>
					</p>
					<FormattedMessage
						id='opportunityCarInsurance.howItWorks.stepOneExtra'
						defaultMessage='Additional coverages are not included in this initial comparison. You can add these yourself when you calculate the premium.'
					/>
				</div>
			</PointItem>
			<PointItem>
				<IconDocumentLoop />
				<FormattedMessage
					id='opportunityCarInsurance.howItWorks.stepTwo'
					defaultMessage='To calculate the savings, we share your personal and insurance data with our partner poliswijzer.nl. Poliswijzer.nl prepares the comparison based on the current available premium. It is therefore possible that the premium conditions of your current car insurance are different from those currently offered.'
				/>
			</PointItem>
		</PointList>
		<ButtonGroup center>
			{onStepBack && (
				<ButtonText
					label={<FormattedMessage id='opportunityCarInsurance.buttonBack' defaultMessage='Back' />}
					onClick={() => onStepBack()}
				/>
			)}
		</ButtonGroup>
	</Card>
)
